/** За сколько секунд до конца срока кнопка «Завершить» желтеет. */
export const SKORO_SEK = 30;

/** `tel.pult.extend_min` — «+{n} мин». */
export function slovoMinut(word: (name: string) => string, n: number): string {
  return word('extend_min').replace('{n}', String(n));
}
